<template>
  <div>
    <!-- <p class="c-inner-title">关键字管理</p> -->
    <div class="auto">
      <page-title title="关键字管理" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="addHandle" class="el-icon-plus" size="small"> 添加关键字</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-select v-model="filter.type" placeholder="请选择回复类型" size="small" class="m-lr-5">
                <el-option
                  key=""
                  label="请选择回复类型"
                  value="">
                </el-option>
                <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)">
                </el-option>
              </el-select>
              <el-select v-model="filter.status" placeholder="请选择状态" size="small">
                <el-option
                  key=""
                  label="请选择状态"
                  value="">
                </el-option>
                <el-option
                  v-for="item in statusSearchOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)">
                </el-option>
              </el-select>
              <el-input placeholder="搜索名称" v-model.trim="filter.search" clearable class="m-lr-5" style="width:200px;" size="small"></el-input>
              <el-button type="primary" @click="handleChangeFilter" size="small">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="name" label="任务名称"></el-table-column>
            <el-table-column prop="type_name" label="回复类型"></el-table-column>
            <el-table-column prop="keyword" label="关键词"></el-table-column>
            <el-table-column prop="content" label="回复内容">
              <template slot-scope="scope">
                <p v-for="(item, index) in scope.row.content" :key="index">
                  {{index}} |
                  <span v-if="item.type === 'text'" v-html="item.content"></span>
                  <span v-else-if="item.type === 'news'">本地多图文</span>
                  <span v-else-if="item.type === 'local_text'">本地文本</span>
                  <span v-else-if="item.type === 'mpnews'">微信图文</span>
                  <span v-else-if="item.type === 'article'">已发布文章</span>
                  <span v-else-if="item.type === 'image'">微信图片</span>
                  <span v-else-if="item.type === 'voice'">微信语音</span>
                  <span v-else-if="item.type === 'video'">本地视频</span>
                  <span v-else-if="item.type === 'music'">本地音乐</span>
                  <span v-else-if="item.type === 'local_miniprogrampage'">本地小程序</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="begin_time" label="开始时间"></el-table-column>
            <el-table-column prop="end_time" label="结束时间"></el-table-column>
            <el-table-column prop="update_time" label="最后更新时间"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <span class="blue" v-if="scope.row.status === '2'">开启</span>
                <span class="red" v-else>关闭</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="220">
              <template slot-scope="scope">
                <el-button
                  @click="editHandle(scope.$index)"
                  type="primary"
                  size="small">
                  修改
                </el-button>
                <el-button
                  @click="copyHandle(scope.row.id)"
                  type="primary"
                  size="small">
                  复制
                </el-button>
                <el-button
                  :disabled="errLoading"
                  @click="errorHandle(scope.row.id)"
                  size="small">
                  错误
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="关键字操作" :modal-append-to-body="false" :visible.sync="dialogVisible" :close-on-press-escape="false" v-loading="btnLoading" :close-on-click-modal="false" fullscreen @close="handleExit">
      <el-row>
        <el-col :span="12">
          <el-form ref="formTable" :rules="rules" :model="form" label-width="120px" size="small">
            <el-form-item prop="name" label="标题">
              <el-input v-model.trim="form.name" placeholder=""></el-input>
            </el-form-item>
            <el-form-item prop="target" label="回复类型">
              <el-select v-model="form.target" placeholder="请选择">
                <el-option
                  v-for="item in formTypeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="qrcode" label="二维码" v-show="form.target === 'scan' || form.target === 'subscribe' || form.target === 'scan_subscribe'">
              <el-select v-model="form.qrcode" filterable remote reserve-keyword :remote-method="remoteMethod" :loading="selectLoading" placeholder="请选择">
                <el-option
                  v-for="item in qrcodeList"
                  :key="item.qrcode_id"
                  :label="item.name"
                  :value="item.qrcode_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="text" label="回复关键字" v-show="form.target === 'message'">
              <el-input type="text" v-model.trim="form.text"></el-input>
            </el-form-item>
            <el-form-item prop="menuClick" label="菜单" v-show="form.target === 'click_event'">
              <el-select v-model="form.menuClick" placeholder="请选择">
                <el-option
                  v-for="item in menuClickList"
                  :key="item.value"
                  :label="item.idx + '-' + item.sub_idx + ' ' + item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="content" label="回复内容">
              <div v-if="form.content.length < 8">
                <el-button @click="openMaterialDialog">+ 添加{{form.content.length > 0 ? '/修改' : ''}}回复内容</el-button>
              </div>
              <div v-if="form.content.length > 0" :style="form.content.length > 0 && form.content.length < 8 ? 'margin-top: 15px;' : ''">
                <material-show v-model="form.content"></material-show>
              </div>
            </el-form-item>
            <el-form-item label="回流监控" prop="is_tk" v-show="showTk">
              <el-radio v-model="form.is_tk" label="1">是</el-radio>
              <el-radio v-model="form.is_tk" label="0">否</el-radio>
            </el-form-item>
            <el-form-item prop="contentType" label="多内容回复类型">
              <el-select v-model="form.contentType" placeholder="请选择">
                <el-option
                  v-for="item in contentTypeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="begin" label="开始时间">
              <el-date-picker
                v-model="form.begin"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="end" label="结束时间">
              <el-date-picker
                v-model="form.end"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="status" label="是否开启">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="remark" label="备注">
              <el-input type="textarea" v-model.trim="form.remark"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSubmit" :loading="btnLoading">提交</el-button>
              <el-button @click="handleExit">取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="2">
          <span style="color:#fff;">1</span>
        </el-col>
        <el-col :span="10">
          <material-menu-phone v-model="form.content" :message="true" :menu="false"></material-menu-phone>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="选择素材" :modal-append-to-body="false" :visible.sync="materialVisible" width="1000px">
      <material-box v-model="form.content"></material-box>
    </el-dialog>
    <el-dialog title="错误信息" :modal-append-to-body="false" :visible.sync="errorVisible" width="1000px">
      <el-table :data="errTotalData" style="width: 100%">
        <el-table-column label="openid" width="280">
          <template slot-scope="scope">
            {{scope.row.openid}}
          </template>
        </el-table-column>
        <el-table-column label="errcode" width="100">
          <template slot-scope="scope">
            {{JSON.parse(scope.row.result_msg)['errcode']}}
          </template>
        </el-table-column>
        <el-table-column label="errmsg">
          <template slot-scope="scope">
            {{JSON.parse(scope.row.result_msg)['errmsg']}}
          </template>
        </el-table-column>
      </el-table>
      <div v-if="errLimit < errTableData.length" class="main-page m-t-10 p-none">
        <el-pagination
          @size-change="errSizeChange"
          @current-change="errCurrentChange"
          :current-page="errPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="errLimit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="errTableData.length">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Mp } from '@/model'
export default {
  data () {
    return {
      showTk: false,
      content: '',
      date: [],
      keywords: '',
      currentId: '',
      dialogVisible: false,
      tableData: [],
      materialVisible: false,
      curMaterialTag: 'news',
      search: '',
      form: {
        name: '',
        text: '',
        type: '',
        target: '',
        remark: '',
        status: '',
        content: [],
        contentData: [],
        contentType: '',
        begin: '',
        end: '',
        qrcode: '',
        menuClick: '',
        keyword: '',
        is_tk: '1'
      },
      rules: {
        name: [
          { required: true, message: '关键字不能为空！', trigger: 'blur' }
        ],
        text: [
          { required: true, message: '回复关键字不能为空！', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '回复内容不能为空！', trigger: 'blur' }
        ],
        target: [
          { required: true, message: '回复类型不能为空！', trigger: 'blur' }
        ],
        qrcode: [
          { required: true, message: '请选择二维码！', trigger: 'blur' }
        ],
        menuClick: [
          { required: false, message: '请选择菜单！', trigger: 'blur' }
        ]
      },
      loading: false,
      typeId: '',
      formClone: {},
      levelOptions: [
        {id: 1, name: '精准'},
        {id: 2, name: '模糊'}
      ],
      statusOptions: [
        {id: 2, name: '开启'},
        {id: 1, name: '关闭'}
      ],
      contentTypeOptions: [
        {id: 1, name: '连续'},
        {id: 2, name: '随机'}
      ],
      statusId: '',
      statusSearchOptions: [
        {id: 2, name: '开启'},
        {id: 1, name: '关闭'}
      ],
      typeOptions: [],
      formTypeOptions: [],
      btnLoading: false,
      qrcodeList: [],
      menuClickList: [],
      selectLoading: false,
      filter: {
        type: '',
        status: '',
        search: '',
        page: '1',
        limit: '20'
      },
      total: 0,
      errLoading: false,
      errorVisible: false,
      errTableData: [],
      errTotalData: [],
      errPage: 1,
      errLimit: 10
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    },
    'form.content': function (val) {
      if (val.length > 7) {
        this.materialVisible = false
      }
      var showTk = false
      this.form.content.map(item => {
        if (item['type'] === 'local_text' || item['type'] === 'news') {
          showTk = true
        }
      })
      this.showTk = showTk
    },
    'form.target': function (val) {
      if (val === 'message') {
        this.rules.text[0].required = true
        this.rules.qrcode[0].required = false
        this.rules.menuClick[0].required = false
        this.form.qrcode = ''
        this.form.menuClick = ''
      } else if (val === 'scan' || val === 'subscribe' || val === 'scan_subscribe') {
        this.rules.text[0].required = false
        this.rules.qrcode[0].required = true
        this.rules.menuClick[0].required = false
        this.form.text = ''
        this.form.menuClick = ''
      } else if (val === 'click_event') {
        this.rules.text[0].required = false
        this.rules.qrcode[0].required = false
        this.rules.menuClick[0].required = true
        this.form.text = ''
        this.form.qrcode = ''
      } else {
        this.rules.text[0].required = false
        this.rules.qrcode[0].required = false
        this.rules.menuClick[0].required = false
        this.form.text = ''
        this.form.qrcode = ''
        this.form.menuClick = ''
      }
    },
    'curMaterialTag': function (val) {
      this.keywords = ''
      this.date = []
    }
  },
  methods: {
    errSizeChange (size) {
      this.errPage = 1
      this.errCurrentChange()
    },
    errCurrentChange (val) {
      this.errPage = val
      var tableData = Object.assign([], this.errTableData)
      this.errTotalData = tableData.splice((this.errPage - 1) * this.errLimit, this.errLimit)
    },
    async errorHandle (id) {
      this.errLoading = true
      let res = await Mp.System.getErrorList({id: id})
      if (res && !res['err_code']) {
        if (!res['data'].length) {
          this.$message.success('没有错误！')
        } else {
          this.errTableData = res['data']
          this.errorVisible = true
          this.errPage = 1
          this.errCurrentChange()
        }
      }
      this.errLoading = false
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        type: '',
        status: '',
        search: '',
        page: '1',
        limit: '20'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/system/reply', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getAutoReplyList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    openMaterialDialog () {
      this.materialVisible = true
    },
    addHandle (index, data) {
      this.form.type = this.levelOptions[0].id
      this.form.status = this.statusOptions[0].id
      this.form.contentType = this.contentTypeOptions[0].id
      this.form.target = this.formTypeOptions[0].id
      this.dialogVisible = true
    },
    async editHandle (index) {
      var data = this.tableData[index]
      this.currentId = data.id
      this.form = {
        name: data.name || data.keyword,
        text: data.keyword,
        type: Number(data.match_type),
        target: data.type,
        remark: data.remark,
        status: Number(data.status),
        content: [],
        contentData: [],
        is_tk: String(data.is_tk),
        contentType: Number(data.content_type),
        begin: data.begin_time,
        end: data.end_time,
        qrcode: data.type === 'click_event' || data.type === 'scan' || data.type === 'subscribe' ? data.keyword : '',
        menuClick: data.type === 'click_event' || data.type === 'scan' || data.type === 'subscribe' ? data.keyword : '',
        keyword: data.keyword
      }
      let res = await Mp.System.decodeContent({id: data.id})
      for (var i = 0; i < res['data'].length; i++) {
        var item = res['data'][i]['info'] || {
          invalid: true
        }
        item['type'] = res['data'][i]['type']
        item['choose'] = true
        this.form.content.push(item)
      }
      // var showTk = false
      // this.form.content.map(item => {
      //   if (item['type'] === 'local_text' || item['type'] === 'news') {
      //     showTk = true
      //   }
      // })
      // this.showTk = showTk
      // console.log(this.form.content)
      this.dialogVisible = true
    },
    handleSubmit () {
      this.$refs['formTable'].validate((valid) => {
        if (valid) {
          this.form.contentData = []
          for (var i = 0; i < this.form.content.length; i++) {
            var item = {}
            item['type'] = this.form.content[i].type
            if (this.form.content[i].type === 'text') {
              item['content'] = this.form.content[i].id
            } if (this.form.content[i].type === 'article') {
              item['content'] = this.form.content[i][0].id || this.form.content[i][0].article_id
            } else if (this.form.content[i].type === 'miniprogrampage') {
              item['content'] = {
                title: this.form.content[i].content.title,
                appid: this.form.content[i].content.appid,
                pagepath: this.form.content[i].content.pagepath,
                thumb_media_id: this.form.content[i].content.thumb_media_id
              }
            } else {
              item['content'] = this.form.content[i].media_id || this.form.content[i].id || this.form.content[i][0].media_id
            }
            this.form.contentData.push(item)
          }
          this.addSubmitFn()
        } else {
          this.$message.error('请按要求填写所有内容！')
          return false
        }
      })
    },
    async addSubmitFn () {
      this.btnLoading = true
      var keyword
      if (this.form.target === 'message') {
        keyword = this.form.text
      } else if (this.form.target === 'scan' || this.form.target === 'subscribe' || this.form.target === 'scan_subscribe') {
        keyword = this.form.qrcode
      } else if (this.form.target === 'click_event') {
        keyword = this.form.menuClick
      } else {
        keyword = ''
      }
      let form = {
        id: this.currentId,
        keyword: keyword,
        type: this.form.target,
        match_type: this.form.type,
        content: this.form.contentData,
        content_type: this.form.contentType,
        begin_time: this.form.begin,
        end_time: this.form.end,
        status: this.form.status,
        remark: this.form.remark,
        qrcode: this.form.qrcode,
        menu_click: this.form.menuClick,
        name: this.form.name
      }
      if (this.showTk) {
        form['is_tk'] = this.form.is_tk
      }
      let res = await Mp.System.saveAutoReply(form)
      if (!res.err_code) {
        this.$message.error('添加失败，请重新添加')
      } else {
        if (res.err_code === '0') {
          if (this.currentId === '') {
            this.resetFilter()
          }
          this.getAutoReplyList()
          this.handleExit()
        } else {
          this.$message.error(res.err_msg)
        }
      }
      this.btnLoading = false
    },
    handleExit () {
      this.dialogVisible = false
      this.form = {
        name: '',
        text: '',
        type: this.levelOptions[0].id,
        target: this.formTypeOptions[0].id,
        remark: '',
        status: this.statusOptions[0].id,
        content: [],
        contentData: [],
        contentType: this.contentTypeOptions[0].id,
        begin: '',
        end: '',
        qrcode: '',
        menuClick: '',
        keyword: '',
        is_tk: '1'
      }
      this.showTk = false
      for (var key in this.materialArr) {
        this.materialArr[key].map((item, index) => {
          item['choose'] = false
        })
      }
      this.currentId = ''
    },
    async getTagTypeList () {
      let res = await Mp.System.getTypeList()
      if (!res.err_code) {
        for (var key in res['data']) {
          this.typeOptions.push({
            name: res['data'][key],
            id: key
          })
          this.formTypeOptions.push({
            name: res['data'][key],
            id: key
          })
        }
      }
    },
    async getAutoReplyList () {
      this.loading = true
      let res = await Mp.System.getAutoReplyList(this.filter)
      let totalData = []
      res['data']['list'].map(item => {
        item['content_type'] = String(item['content_type'])
        item['match_type'] = String(item['match_type'])
        item['status'] = String(item['status'])
        totalData.push(item)
      })
      this.tableData = totalData
      this.total = res['data']['total']
      this.loading = false
    },
    async getMenuClickAndQrcodeList () {
      let qrcodeRes = await Mp.System.getQrcodeList()
      this.qrcodeList = qrcodeRes['data']
      let menuRes = await Mp.System.getMenuClickList()
      this.menuClickList = menuRes['data']
    },
    async remoteMethod (query) {
      let qrcodeRes = await Mp.System.getQrcodeList({name: query})
      this.qrcodeList = qrcodeRes['data']
    },
    copyHandle (id) {
      this.$confirm('确定要复制吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.copyFn(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消复制'
        })
      })
    },
    async copyFn (id) {
      this.loading = true
      let res = await Mp.System.copyAutoReply({id: id})
      if (!Number(res['err_code'])) {
        this.getAutoReplyList()
      } else {
        this.$message({
          type: 'error',
          message: res['err_msg']
        })
      }
    }
  },
  created () {
    this.queryToFilter()
    this.getTagTypeList()
    this.getMenuClickAndQrcodeList()
    this.formClone = Object.assign({}, this.form)
  }
}
</script>

<style scoped>
.el-tag { margin-right: 5px; }
.el-checkbox.el-checkbox-rigth { margin-left: 0; margin-right: 15px; }

.masonry {
  column-count: 4;
  column-gap: 10;
  padding-bottom: 40px;
}
.list-box {
  /*width: 240px;*/
  width: 100%;
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 5px;
  border: 1px solid #eee;
  float: left;
  margin: 5px 0;
  break-inside: avoid;
  box-sizing: border-box;
}
.list-box-cur {
  border: 1px solid #409EFF;
  box-shadow: 0 0 5px rgba(64,158,255,.1);
}
.listbox-top {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  position: relative;
}
.listbox-top dl dt {
  font-size: 16px;
}
.noposter dd {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.hasposterBox {
  position: relative;
  height: auto;
  overflow: hidden;
}
.hasposter {
  position: relative;
}
.hasposter dt {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px 5%;
  background: rgba(0,0,0,.55);
  color: #fff;
  width: 90%;
}
.hasposter dd {
  max-height: 130px;
  overflow: hidden;
}
.hasposter dd img{
  width: 100%;
  display: block;
}
.listbox-top a {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 10px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-top:hover a {
  display: block;
}
.listbox-top a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 45%;
  /*margin-top: -10px;*/
}
.listbox-item {
  width: 100%;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.listbox-item dl {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.listbox-item dl dt {
  position: absolute;
  right: 70px;
  left: 0;
  font-size: 14px;
  line-height: 20px;
  height: 60px;
  overflow: hidden;
}
.listbox-item dl dd {
  width: 60px;
  height: 60px;
  float: right;
  background: #eee;
}
.listbox-item dl dd img{
  width: 100%;
}
.listbox-itembox {
  position: relative;
}
.listbox-itembox a{
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-itembox:hover a {
  display: block;
}
.listbox-itembox a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 30%;
  /*margin-top: -10px;*/
}
.list-box .control{
  margin-top: 10px;
  text-align: right;
}
.list-box .control a{
  color: #409EFF;
}

.paBox{
  max-width: 240px;
}
.patop {
  border: 1px solid #eee;
  padding: 10px;
  position: relative;
}
.imgbox{
  background: #eee;
  width: 100%;
  min-height: 120px;
  max-height: 120px;
  overflow: hidden;
  position: relative;
}
.imgbox img{
  max-width: 100%;
  max-height: 100%;
}
.imgbox p{
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.2);
}
.imgbox p span{
  display: block;
  padding: 10px;
  color: #fff;
  left: 0;
  bottom: 0;
  position: absolute;
  font-size: 14px;
  line-height: 18px;
  max-height: 36px;
  overflow: hidden;
}
.pamask{
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid #409EFF;
}
.palist:hover .patopedit {
  display: block;
}
.patopedit {
  position: absolute;
  width: 100%;
  background: rgba(0,0,0,.8);
  left: 0;
  bottom: 0;
  padding: 10px 0;
  display: none;
}
.patopedit i{
  color: #fff;
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.palist {
  position: relative;
  border: 1px solid #eee;
  /*margin-top: -1px;*/
  padding: 10px;
  height: auto;
  height: 60px;
}
.palist dl dd{
  width: 60px;
  height: 60px;
  background: #eee;
  float: right;
  overflow: hidden;
}
.palist dl dd img{
  max-width: 100%;
  max-height: 100%;
}
.palist dl dt{
  position: absolute;
  left: 10px;
  top: 10px;
  height: 60px;
  line-height: 60px;
  overflow: hidden;
}
.paAdd {
  cursor: pointer;
  border: 1px dashed #eee;
  max-width: 238px;
  text-align: center;
  padding: 20px 0;
  border-top: none;
}
.paAdd i{
  font-size: 30px;
}
.dialogControl{
  padding-top: 10px;
  text-align: right;
}
.dialogControl span {
  float: left;
  font-size: 12px;
}
.dialogControl a {
  float: right;
}
.transitionBox {
  width: 11%;
  float: left;
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 5px;
  border: 1px solid #eee;
  float: left;
  margin: 10px 10px 0 0;
  break-inside: avoid;
  box-sizing: border-box;
}
.transitionBox .dialogControl{
  padding-top: 10px;
  line-height: 14px;
}

span.blue{
  color: #409EFF;
}
span.red{
  color: red;
}

.uploadimg {
  width: 150px;
  cursor: pointer;
}

.local_text {
  word-break: break-all;
}
.miniimgtitle {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.miniimgbox {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  margin: 10px 0;
  border-bottom: 1px solid #eee;
}
.miniimgbox img {
  width: 100%;
}
.materialimg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
</style>
